export const tabLanguageLogos = {
  height: '20px',
  width: '20px',
  verticalAlign: 'middle',
  marginRight: '5px'
};
